export enum AnimatedSliderLayout {
  Horizontal = "title-description-horizontal",
  Vertical = "title-description-cta-vertical",
}

export enum AnimatedSliderState {
  INITIAL,
  TRANSITION,
  FINAL,
}
